
import { ScrollArea } from "@/components/ui/scroll-area";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function Terms() {
  return (
    <div className="container max-w-4xl py-8 px-4">
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl font-bold">Terms of Service</CardTitle>
        </CardHeader>
        <CardContent>
          <ScrollArea className="h-[600px] pr-4">
            <div className="space-y-6">
              <section>
                <h2 className="text-xl font-semibold mb-3">1. Acceptance of Terms</h2>
                <p className="text-muted-foreground">
                  By accessing and using ChargeShare, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">2. Description of Service</h2>
                <p className="text-muted-foreground">
                  ChargeShare provides an online platform connecting electric vehicle owners with charging station hosts. We facilitate the discovery, booking, and payment for EV charging services.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">3. User Accounts</h2>
                <p className="text-muted-foreground">
                  Users must register for an account to access certain features. You are responsible for maintaining the confidentiality of your account information and for all activities under your account.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">4. Charging Station Listings</h2>
                <p className="text-muted-foreground">
                  Hosts are responsible for providing accurate information about their charging stations. ChargeShare reserves the right to remove any listing that violates our policies or terms of service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">5. Booking and Payments</h2>
                <p className="text-muted-foreground">
                  All payments are processed through our secure payment system. Cancellation policies may vary by host and will be clearly displayed before booking.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">6. User Conduct</h2>
                <p className="text-muted-foreground">
                  Users agree to use the service in compliance with all applicable laws and regulations. Prohibited conduct includes harassment, fraud, and any activity that disrupts the service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">7. Privacy</h2>
                <p className="text-muted-foreground">
                  Our collection and use of personal information is governed by our Privacy Policy. By using ChargeShare, you consent to our data practices described in the Privacy Policy.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">8. Intellectual Property</h2>
                <p className="text-muted-foreground">
                  All content and materials available on ChargeShare are protected by intellectual property laws. Users may not copy, modify, or distribute our content without permission.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">9. Limitation of Liability</h2>
                <p className="text-muted-foreground">
                  ChargeShare is not liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">10. Changes to Terms</h2>
                <p className="text-muted-foreground">
                  We reserve the right to modify these terms at any time. Users will be notified of significant changes, and continued use of the service constitutes acceptance of modified terms.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">11. Contact Information</h2>
                <p className="text-muted-foreground">
                  For questions about these Terms of Service, please contact us at support@chargeshare.com
                </p>
              </section>
            </div>
          </ScrollArea>
        </CardContent>
      </Card>
    </div>
  );
}
